import React from 'react';
import {Link} from "react-router-dom";

import * as queryString from 'query-string';

import {DISABLED_ROUTE_IF_COURSE_FINISHED} from "../../costanti";
import {dayJS} from "../../applicationConf";


const CorsoDettaglioLink = ({dati, objLink}) => {

    const analyzeSearch = (searchObj) => {
        let searchString = '';
        if (dati.dataFine != null && dayJS().isSameOrAfter(dayJS(dati.dataFine, 'YYYY-MM-DD'), 'month')) {
            for (const key in searchObj) {
                if (searchObj.hasOwnProperty(key)) {
                    searchString += searchString === '' ? '?' : '&';
                    if (dayJS(searchObj[key]).isValid()) {
                        if (key == 'page') {
                            searchString += '&page=1'
                        } else {
                            searchString += queryString.stringify({[key]: dayJS(dati.dataFine).format('YYYY-MM')})
                        }
                    } else {
                        searchString += queryString.stringify({[key]: searchObj[key]});
                    }
                }
            }
            return searchString;
        } else {
            return `?${queryString.stringify(searchObj)}`
        }
    }

    const isDisabled = () => {
        return DISABLED_ROUTE_IF_COURSE_FINISHED.includes(objLink.DISPLAY_VALUE) && (dati.dataFine != null &&
            dayJS().isAfter(dayJS(dati.dataFine, 'YYYY-MM-DD'), 'day'));
    }

    return (
        <>
            <Link to={{
                pathname: `/corso/${dati.id}${objLink.LINK}`,
                search: objLink.hasOwnProperty('SEARCH') ? analyzeSearch(objLink.SEARCH) : '',
                hash: objLink.hasOwnProperty('FRAGMENT') ? objLink.FRAGMENT : ''
            }}>
                <button type='button'
                        style={{cursor: isDisabled() ? 'not-allowed' : 'pointer'}}
                        className="btn btn-primary mt-2 shadow"
                        disabled={isDisabled()}>
                    {objLink.DISPLAY_VALUE}
                </button>
            </Link>
            &nbsp;
        </>
    )
};

export default CorsoDettaglioLink;
